import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../componentCss/webform.css";
import { Link, useParams } from "react-router-dom";
import Dashboardheader from "./dashboardheader";
import Header from './Header';
import Footer from './Footer';
import AssignedFormSidebar from "./assignedFormSidebar";
import "../componentCss/sidebar.css";
import {
  getFormDataListAction,
  getFormDetailsAction,
  getPatientDetailsAction,
  getAllReportContentAction,
  getStaffListAction
} from "../../Action/admin.action";
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from './decrypt';
import config from "../../config/config";
import ReactToPrint, { useReactToPrint } from 'react-to-print';

const patientMrnNumber = '';
const today = new Date();
const options = { day: '2-digit', month: 'long', year: 'numeric' };
const todayDate = today.toLocaleDateString('en-GB', options);


const formTitles = {
  121: "PRE HD Report",
  122: "DURING HD Report",
  123: "POST HD Report"
};


const EditFormData = () => {
  let { formId, recordId, name } = useParams();
  const formIdList = formId.split(','); // Support multiple formIds

  const [formList, setFormData] = useState({});
  const [formLists, setFormLists] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [reason, setReason] = useState('');
  const [reasonStatus, setReasonStatus] = useState('');
  const [patientDetails, setPatientDetails] = useState([]);
  const [reportData, setReportData] = useState('');
  const [staffFormEditPermission, setStaffFormEditPermission] = useState({});
  const allDataRef = useRef();
  const allDataRefRecords = useRef();

  useEffect(() => {
    getReportContentList();
    getPatientDetailsAPI();
    getPatientFormData();

    formIdList.forEach(id => {
      getFormDetailsAPI(id);
      getFormDataListAPI(id);
    });
  }, []);

  const getReportContentList = async () => {
    let res = await getAllReportContentAction();
    if (res.success) {
      let decryptedData = decryptData(res.data);
      setReportData(decryptedData);
    }
  };

  const getFormDetailsAPI = async (id) => {
    let res = await getFormDetailsAction(id);
    if (res.success) {
      setFormDetails(prev => ({
        ...prev,
        [id]: decryptData(res.data)
      }));
      setStaffFormEditPermission(prev => ({
        ...prev,
        [id]: decryptData(res.staffFormEditPermission)
      }));
    }
  };
  
  


  const getFormDataListAPI = async (id) => {
    let res = await getFormDataListAction({ id, recordId, mrnNumber: recordId, report_type: "query_report"});
    if (res.success) {
      let data = decryptData(res.data?.records);
    //   localStorage.setItem('mrnNumber', data[0].mrnNumber);

      setFormLists(prev => ({
        ...prev,
        [id]: data[0]
      }));

      setReason(decryptData(res.data.reasonOfRecord));
      setReasonStatus(decryptData(res.data.reasonStatus));
    }
  };

  const getPatientFormData = async () => {
    
    let pa = await getFormDataListAction({ id: 3, recordId: recordId, mrnNumber: recordId, report_type: "query_report" });
    if (pa.success) {
        let user = await getStaffListAction();
        let data = decryptData(pa.data?.records);
        setFormData(data[0])
        if (user.success){
            let usersData = decryptData(user.data);
            const singleUserData = usersData.filter(user => (`${user.firstName} ${user.lastName}`.trim()).includes(data[0]["staffName"]));
            setUserDetails(singleUserData)
        }

    }
  }
  const getPatientDetailsAPI = async () => {
    let value = recordId.replace(/"/g, ''); 
    let res = await getPatientDetailsAction({ mrnNumber: value });
    if (res.success) {
      let data = decryptData(res.data);
    //   const extractedValues = data.filter(item => item.formDetailsId === 16 || item.formDetailsId === 18).map(item => item.mrnNumber);
      setPatientDetails(data);
    }
  };

  const printAllData = useReactToPrint({ content: () => allDataRef.current });
  const printAllDataRecords = useReactToPrint({ content: () => allDataRefRecords.current });
  const printRef = useRef();
  return (
    <>
      <Dashboardheader />
      <div className="wrapper">
        <div id="content">
          <Container fluid className="p-4">
            <Row>
              {/* <Col lg={3}><AssignedFormSidebar /></Col> */}
              <Col lg={9}>
                <div className="form-preview-container">

                <ReactToPrint
                  trigger={() => <Button variant="primary">Print This Page</Button>}
                  content={() => printRef.current}
                  documentTitle="Report"
                  pageStyle="@media print { body { -webkit-print-color-adjust: exact; } }"
                />
                <div ref={printRef} className="print-container">
                  <br></br>
                <Header formList={formList} />



                
                  <h2>{name} Record Details</h2>
                  <Link to={`${config.baseUrl}viewTreatment/${formId}/${recordId}/${name}`}>
                    <span style={{ float: 'right', marginTop: '-15px' }}>Back</span>
                  </Link>

                  {formIdList.map((id, idx) => {
                    const form = formLists[id];
                    const details = formDetails[id];
                    const title = formTitles[id]
                    if (!form || !details || Object.keys(form).length === 0 || details.length === 0) {
                        return (
                          <div key={id} className="mb-4">
                            <h4 className="text-primary">{title}</h4>
                            <p className="text-danger">No data found for this form.</p>
                          </div>
                        );
                      }
                      

                    return (
                      <div key={id} className="mb-4">
                        <h4 className="text-primary">{title}</h4>
                        <ul className="list-group">
                          <li className="list-group-item"><strong>MRN:</strong> {form.mrnNumber}</li>
                          <li className="list-group-item"><strong>Emirates ID:</strong> {form.emrNumber}</li>

                          {details.map((field, index) => (
                            <li key={index} className="list-group-item d-flex flex-row">
                              <div className="w-50"><strong>{field.fieldName}:</strong></div>
                              {field.fieldtype === 'file' ? (
                                <a href={`${form[field.id]}`} target="_blank" rel="noreferrer">
                                  <button className="btn btn-sm btn-primary">View Document</button>
                                </a>
                              ) : field.fieldtype === 'multipleValue' ? (
                                <ul>
                                  {(() => {
                                        try {
                                            const values = form[field.id] ? JSON.parse(form[field.id]) : [];
                                            return Array.isArray(values) ? values.map((item, idx) => <li key={idx}>{item}</li>) : <li>Invalid data</li>;
                                        } catch (err) {
                                            return <li className="text-danger">Error parsing values</li>;
                                        }
                                    })()}

                                </ul>
                              ) : field.fieldtype === 'masterdata' ? (
                                <div style={{ overflowX: 'auto' }}>
                                  {(() => {
                                        let tableData = [];
                                        try {
                                            tableData = form[field.id] ? JSON.parse(form[field.id]) : [];
                                        } catch (err) {
                                            return <p className="text-danger">Error parsing table data</p>;
                                        }

                                        return Array.isArray(tableData) && tableData.length > 0 ? (
                                            <table className="table table-responsive">
                                            <thead>
                                                <tr>
                                                {Object.keys(tableData[0]).map((key, idx) => (
                                                    <th key={idx}>{key}</th>
                                                ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData.map((item, idx) => (
                                                <tr key={idx}>
                                                    {Object.entries(item).map(([key, val]) => (
                                                    <td key={key}>{typeof val === 'object' ? JSON.stringify(val) : val}</td>
                                                    ))}
                                                </tr>
                                                ))}
                                            </tbody>
                                            </table>
                                        ) : (
                                            <p>No table data</p>
                                        );
                                    })()}

                                </div>
                              ) : form[field.id]}
                            </li>
                          ))}
                        </ul>
                        {staffFormEditPermission[id]?.isEdit === 1 && (
                          <div className="mt-3">
                            {/* <Link to={`${config.baseUrl}editForm-submission/${id}/${recordId}/${name}`}>
                              <button className='btn btn-secondary me-2'>Modify</button>
                            </Link> */}
                            {/* <button className="btn btn-primary" onClick={printAllDataRecords}>Print</button> */}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {reason && (
                    <li className="list-group-item">
                      {reasonStatus == 2 ? <strong>Invalidate:</strong> :
                        reasonStatus == 3 ? <strong>Addendum:</strong> :
                          reasonStatus == 6 ? <strong>Review/Acknowledgement:</strong> : 'Reason'}
                      {reason}
                    </li>
                  )}
                


                  
                <Footer userDetails={userDetails} />
                </div>
                </div>
              </Col>

            </Row>
            

          </Container>
        </div>
      </div>
    </>
  );
};

export default EditFormData;
